/**
 * Supported cryptographic schemes for signing accounts
 */
export var CryptographicScheme;
(function (CryptographicScheme) {
    CryptographicScheme["ECDSA"] = "ECDSA";
    // Future schemes can be added here
    // RSA = 'RSA',
    // EdDSA = 'EdDSA'
})(CryptographicScheme || (CryptographicScheme = {}));
/**
 * Supported elliptic curves for ECDSA
 */
export var EllipticCurve;
(function (EllipticCurve) {
    EllipticCurve["SECP256K1"] = "secp256k1";
    // Future curves can be added here
    // SECP256R1 = 'secp256r1',
    // SECP384R1 = 'secp384r1'
})(EllipticCurve || (EllipticCurve = {}));
/**
 * Network types for blockchain signing
 */
export var NetworkType;
(function (NetworkType) {
    NetworkType["KEY_ECDSA"] = "KeyECDSA";
    // Future network types can be added here
    // ETHEREUM = 'Ethereum',
    // POLYGON = 'Polygon'
})(NetworkType || (NetworkType = {}));
//# sourceMappingURL=crypto.enum.js.map